import { Box } from '@customerio/pluma-components/react';

/** Legacy onboarding personalize step. Placeholder — content lands with the personalize step PR. */
export function OnboardingPersonalizeStep() {
  return <Box data-testid="signup-step-onboarding-personalize" />;
}
